type Props = {
  title: string;
  subTitle?: string;
};

const Title = ({ title, subTitle }: Props) => {
  return (
    <>
      <h1 className="mb-0">{title}</h1>
      {subTitle && <p className="s-text-subtle mt-16 mb-0 font-bold">{subTitle}</p>}
    </>
  );
};

export default Title;
